/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:24:55
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/toolbar.js
 */
export default {
    // toolbar 组件
    toolbar: {
        show: true,
        cancelText: '取消',
        confirmText: '确认',
        cancelColor: '#909193',
        confirmColor: '#3c9cff',
        title: ''
    }

}
